export { DocumentSearch as default } from './DocumentSearch';
